export function authHeader(){

  let authToken = JSON.parse(sessionStorage.getItem('accessToken'));

  if(authToken)
    return {'Authorization': authToken};
  else
    return {};
}